import { gql } from '@apollo/client'

const UPDATE_ENTRY_GROUP = gql`
  mutation updateEntryGroup(
    $entryGroupInfo: UpdateEntryGroupInput!
    $entryInfo: [UpdateEntryInput!]!
    $nonprofitOrgId: Int!
  ) {
    updateEntryGroup(
      entryGroupInfo: $entryGroupInfo
      entryInfo: $entryInfo
      nonprofitOrgId: $nonprofitOrgId
    ) {
      id
    }
  }
`

export default UPDATE_ENTRY_GROUP
